





































































































































import {
  defineComponent,
  computed,
  reactive,
  ref,
} from '@vue/composition-api';
import _ from 'lodash';
import { useRouter } from '@ideavivat/vivat-2';
import { useQuery } from '@vue/apollo-composable';
import PrettyCheck from 'pretty-checkbox-vue/check';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonProductTypeSelect from '@/components/Product/CommonProductTypeSelect.vue';
import CommonUploadProductModal from '@/components/Product/CommonUploadProductModal.vue';

import getAllAreaCodes from '@/gql/areaCode/getAllAreaCodes.gql';
import getProducts from '@/gql/product/getProducts.gql';
import getProduct from '@/gql/product/getProduct.gql';

import { toCommaFormat } from '@/utils';
import productTableList from '@/table/product/productList';
import { Area } from '@/useDeliveryAreaCode';
import useDownloadReport from '@/useDownloadReport';

const ProductList = defineComponent({
  components: {
    PrettyCheck,
    CommonModalWithPreset,
    CommonProductTypeSelect,
    CommonUploadProductModal,
  },
  setup() {
    const { router } = useRouter();
    const showPriceModal = ref(null);
    const filter = reactive({
      status: '',
      search: undefined,
      type: undefined,
      productId: undefined,
      orderBy: {
        column: 'created_at',
        order: 'DESC',
      },
    });

    const { result: getAreasDetails, loading } = useQuery(getAllAreaCodes, () => ({ filter: { column: 'ACTIVE', value: true }, orderBy: [{ column: 'CODE', order: 'ASC' }] }));
    const getAreasCode = computed(() => getAreasDetails.value?.areas || []);

    const sortByAreaCode = (elm: any, elm2: any) => elm.area.code - elm2.area.code;
    function processAreaPriceArray(array: any) {
      const newArr = _.cloneDeep(array);
      return newArr.sort(sortByAreaCode);
    }

    const { result: getProductAreaCode } = useQuery(getProduct, () => ({ id: filter.productId }), () => ({ fetchPolicy: 'network-only' }));
    const areaPriceByProduct = computed(() => processAreaPriceArray(getProductAreaCode.value?.product.areaPriceByProduct || []));
    const areaPriceByWeight = computed(() => processAreaPriceArray(getProductAreaCode.value?.product.areaPriceByWeight || []));
    const areaPriceByVolume = computed(() => processAreaPriceArray(getProductAreaCode.value?.product.areaPriceByVolume || []));

    const computedDisplayAreaPrice = computed(() => {
      const result: { [key: string]: { weight: any; product: any; volume: any } } = {};
      getAreasCode.value.forEach((area: Area) => {
        const product = areaPriceByProduct.value.find((item: any) => item.area.code === area.code);
        const weight = areaPriceByWeight.value.find((item: any) => item.area.code === area.code);
        const volume = areaPriceByVolume.value.find((item: any) => item.area.code === area.code);

        result[area.code] = {
          product,
          weight,
          volume,
        };
      });

      return result;
    });

    const { result: getProductsDetails, loading: getProductsDetailsLoading } = useQuery(getProducts, () => ({}), () => ({
      fetchPolicy: 'network-only',
    }));
    const getTotalProducts = computed(() => getProductsDetails.value?.products?.paginatorInfo?.total || 0);
    const getProductsResult = (data: any) => data.products;

    const handlePriceCheck = (id: any) => {
      (showPriceModal.value as any).open();
      filter.productId = id;
    };
    const computedFilter = computed(() => {
      const vars = {
        where: {
          OR: [],
        },
      };
      if (filter.search) {
        vars.where.OR.push({ column: 'CODE', operator: 'LIKE', value: `%${filter.search}%` } as never);
        vars.where.OR.push({ column: 'REF_CODE', operator: 'LIKE', value: `%${filter.search}%` } as never);
        vars.where.OR.push({ column: 'NAME', operator: 'LIKE', value: `%${filter.search}%` } as never);
      }
      if (filter.type) {
        vars.where.OR.push({ column: 'PRODUCT_GROUP_ID', operator: 'LIKE', value: (filter.type as any).id } as never);
      }

      return vars;
    });

    const uploadProductModal = ref(null);
    function openUploadProductModal() {
      (uploadProductModal.value as any).open();
    }

    const uploadSuccessModal = ref(null);
    const uploadFailedModal = ref(null);
    function uploadSuccessHandler() {
      (uploadProductModal.value as any).close();
      (uploadSuccessModal.value as any).compose({
        entity: 'ข้อมูลราคา',
        action: 'อัปโหลด',
      });
    }
    function uploadFailedHandler() {
      (uploadFailedModal.value as any).compose();
    }

    function downloadProduct(type = 'WEIGHT') {
      const anchor = document.createElement('a');
      document.body.appendChild(anchor);

      const headers = new Headers();
      headers.append('Authorization', `Bearer ${localStorage.getItem('tms-admin-apollo-token')}`);

      const file = `${process.env.VUE_APP_BACKEND_HTTP}/api/export-product-area-price?priceType=${type}`;

      fetch(file, { headers, method: 'POST' })
        .then((response) => response.blob())
        .then((blobby) => {
          const objectUrl = window.URL.createObjectURL(blobby);

          anchor.href = objectUrl;
          anchor.download = `product-${type}.csv`;
          anchor.click();

          window.URL.revokeObjectURL(objectUrl);
        });
    }

    return {
      downloadProduct,
      toCommaFormat,

      getProductsResult,
      getTotalProducts,

      filter,

      getProducts,
      productTableList,
      computedFilter,
      showPriceModal,

      getProductAreaCode,
      areaPriceByProduct,
      areaPriceByVolume,
      areaPriceByWeight,
      computedDisplayAreaPrice,

      getAreasDetails,
      getAreasCode,

      handlePriceCheck,

      uploadProductModal,
      openUploadProductModal,
      uploadSuccessModal,
      uploadFailedModal,
      uploadSuccessHandler,
      uploadFailedHandler,
    };
  },
});

export default ProductList;
